import axios from "axios";

export default {
  getAllOptions(token) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    return axios
      .get(process.env.CHAPTER_NUMBER + "/options", axiosConfig)
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  getOptionsSubset(token, category) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    return axios
      .get(process.env.CHAPTER_NUMBER + "/options/" + category, axiosConfig)
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  postOption(token, category, option) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url = process.env.CHAPTER_NUMBER + "/options/" + category;
    let body = { option: option };
    return axios
      .post(url, body, axiosConfig)
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  },
  deleteOption(token, category, id) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      }
    };
    let url = process.env.CHAPTER_NUMBER + "/options/" + category + "?id=" + id;
    return axios
      .delete(url, axiosConfig)
      .then(res => res.data)
      .catch(err => console.log("AXIOS ERROR: ", err));
  }
};



// WEBPACK FOOTER //
// ./src/utils/api/options.js